import { render, staticRenderFns } from "./KEDrawer.vue?vue&type=template&id=5580c0cc&scoped=true&"
import script from "./KEDrawer.vue?vue&type=script&lang=ts&"
export * from "./KEDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./KEDrawer.vue?vue&type=style&index=0&id=5580c0cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5580c0cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCloseButton: require('/var/www/packages/theme/components/atoms/CloseButton.vue').default,IconsSpinner: require('/var/www/packages/theme/components/icons/spinner/Spinner.vue').default})
